module.exports = __webpack_public_path__ + "img/t1.385cd5c8.svg";